var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calculator"},[_c('calculator'),_c('div',{staticClass:"login-link"},[_c('h1',[_vm._v(" Gesuch erfassen ")]),_c('p',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Zum Login")])],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }